import type { PaymentModuleId } from '@foundation/apis/payments';

export interface AuthorizationPayload {
  readonly paymentIntentId: string;
  readonly paymentDataTypeId: PaymentModuleId;

  // Id of stored instrument
  readonly paymentDataId?: string;

  readonly mandateReference?: string;

  // Braintree specific
  readonly deviceData?: string;
  readonly nonceToken?: string;

  // Braintree SEPA specific
  readonly ibanLastFour?: string;

  // 'Old' MPM Sepa specific
  readonly accountHolderName?: string;
  readonly iban?: string;

  //LSV specific
  readonly bankName?: string;
}

export function createStoredDirectDebitAuthorizationPayload(
  paymentIntentId: string,
  paymentDataTypeId: PaymentModuleId,
  instrumentId: string,
  mandateReference?: string,
): AuthorizationPayload {
  return {
    paymentIntentId,
    paymentDataTypeId,
    paymentDataId: mandateReference === undefined ? instrumentId : undefined,
    mandateReference,
  };
}
